"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toRem = exports.getRem = void 0;
const getRem = (rem) => {
    const rootStyle = getComputedStyle(document.documentElement);
    const fontSize = parseFloat(rootStyle.fontSize);
    return rem * fontSize;
};
exports.getRem = getRem;
const toRem = (px) => {
    const rootStyle = getComputedStyle(document.documentElement);
    const fontSize = parseFloat(rootStyle.fontSize);
    return px / fontSize;
};
exports.toRem = toRem;
